import { createStructuredSelector } from 'reselect';
import {
  selectAdvisors,
  mapData,
} from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectSelectedCharityEin,
  selectGrantPurposeName,
  selectGrantAmount,
  selectStartDate,
  selectNoOfPayments,
  selectScheduleType,
  selectAllocationType,
  selectGrantRecognition,
  selectSelectedCharityName,
} from './RecommendGrantPageSelectors';

export const selectLoading = (state) => {
  const { isGrantDetailsLoading } = fetchRAGState(state);
  return isGrantDetailsLoading;
};

export const selectCharityId = (state) => {
  const { selectedCharityId } = fetchRAGState(state);
  return selectedCharityId;
};

export const selectCharityAddress = (state) => {
  const { selectedCharityAddress } = fetchRAGState(state);
  return selectedCharityAddress;
};

export const selectEnteredDate = (state) => {
  const { enteredDate } = fetchRAGState(state);
  return enteredDate;
};

export const selectHonorOf = (state) => {
  const { honorOf } = fetchRAGState(state);
  return honorOf;
};

export const selectMemoryOf = (state) => {
  const { memoryOf } = fetchRAGState(state);
  return memoryOf;
};

export const selectNotifyFirstName = (state) => {
  const { notifyFirstName } = fetchRAGState(state);
  return notifyFirstName;
};

export const selectNotifyLastName = (state) => {
  const { notifyLastName } = fetchRAGState(state);
  return notifyLastName;
};

export const selectPublishName = (state) => {
  const { permissionToPublish } = fetchRAGState(state);
  return permissionToPublish;
};

export const selectFrequency = (state) => {
  const { frequency } = fetchRAGState(state);
  return frequency;
};

export const selectAllocations = (state) => {
  const { allocations } = fetchRAGState(state);
  return allocations;
};

export const selectAllSharesAllPools = (state) => {
  const { allSharesAllPools } = fetchRAGState(state);
  return allSharesAllPools;
};

export const selectAllShares = (state) => {
  const { allShares } = fetchRAGState(state);
  return allShares;
};

export const selectEndDate = (state) => {
  const { endDate } = fetchRAGState(state);
  return endDate;
};

export const selectGrantTimeline = (state) => {
  const { grantTimeline } = fetchRAGState(state);
  return grantTimeline;
};

export const selectFastPass = (state) => {
  const { fastPass } = fetchRAGState(state);
  return fastPass;
};

export const selectCharityInterest = (state) => {
  const { selectedCharityInterest } = fetchRAGState(state);
  return selectedCharityInterest;
};

export const selectPurposeId = (state) => {
  const { grantPurposeId } = fetchRAGState(state);
  return grantPurposeId;
};

export const selectAdditionalComments = (state) => {
  const { purposeComments } = fetchRAGState(state);
  return purposeComments;
};

export const selectMissionaryName = (state) => {
  const { missionaryName } = fetchRAGState(state);
  return missionaryName;
};

export const selectEventName = (state) => {
  const { eventName } = fetchRAGState(state);
  return eventName;
};

export const selectMissionaryLocation = (state) => {
  const { missionaryLocation } = fetchRAGState(state);
  return missionaryLocation;
};

export const selectProjectName = (state) => {
  const { projectName } = fetchRAGState(state);
  return projectName;
};

export const selectPurposeCertification = (state) => {
  const { purposeCertification } = fetchRAGState(state);
  return purposeCertification;
};

export const selectStandardLanguage = (state) => {
  const { standardLanguage } = fetchRAGState(state);
  return standardLanguage;
};

export const selectIncludeAdvisorInfo = (state) => {
  const { includeAdvisorInfo } = fetchRAGState(state);
  return includeAdvisorInfo;
};

export const selectThirdParty = (state) => {
  const { advisorThirdPartyComment } = fetchRAGState(state);
  return advisorThirdPartyComment;
};

export const selectAccountName = (state) => {
  const { accountName } = fetchRAGState(state);
  return accountName;
};

export const confirmationPageDerivedStates = createStructuredSelector({
  loading: selectLoading,
  charityId: selectCharityId,
  charityName: selectSelectedCharityName,
  charityAddress: selectCharityAddress,
  charityEin: selectSelectedCharityEin,
  enteredDate: selectEnteredDate,
  inHonorOfName: selectHonorOf,
  inMemoryOfName: selectMemoryOf,
  purposeName: selectGrantPurposeName,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  publishName: selectPublishName,
  grantAmount: selectGrantAmount,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayments: selectNoOfPayments,
  scheduleType: selectScheduleType,
  amountType: selectAllocationType,
  allocations: selectAllocations,
  allSharesAllPools: selectAllSharesAllPools,
  allShares: selectAllShares,
  endDate: selectEndDate,
  grantTimeline: selectGrantTimeline,
  fastPass: selectFastPass,
  charityInterest: selectCharityInterest,
  purposeId: selectPurposeId,
  additionalComments: selectAdditionalComments,
  missionaryName: selectMissionaryName,
  eventName: selectEventName,
  missionaryLocation: selectMissionaryLocation,
  projectName: selectProjectName,
  purposeCertification: selectPurposeCertification,
  standardLanguage: selectStandardLanguage,
  grantRecognition: selectGrantRecognition,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  thirdParty: selectThirdParty,
  accountName: selectAccountName,
  advisors: selectAdvisors,
  codeValueMappingData: mapData,
});
